import React, { useEffect, useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { validateInputText } from "../../../utilities/ValidateUtil";
import classNames from "classnames";
import { DialogShow_2, DialogUpload } from "../../../components/DialogService/DialogService";
import { genGetBranchInfo } from "../../../service/GEN/GenService";
import { dataUserSession } from "../../../utilities/dataSession";
import { formatDateFile } from "../../../utilities/DateUtil";
import { commonUpload } from "../../../service/APP/AppService";
import { genUserStatusList, genUserTypeList, genWorkunitList } from "../../../service/GEN/GenService";
import { Toast } from "primereact/toast";
import { NullString } from "../../../utilities/NullUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";
import Media from "../../../components/Media/Media";
import P401Dialog from "./P401Dialog";
import { P401CreateData, P401CreatePhotoData, P401GetData, P401ContractCopy } from "../../../service/400/P401Service";
import "./P401.css";
import { itemTemplate, panelFooterTemplate, selectedItemsLabel } from "../../../utilities/MultiSelectUtil";
import { deCodeBase64 } from "../../../components/UploadPic/UploadPicUtil";

export default function P401Edit({ action, onChangeAction, searchInfo, setSearchInfo }) {
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);
    const [multiselectValue, setMultiselectValue] = useState([]);
    const [contract, setContract] = useState([]);
    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [textShow, setTextShow] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataFile, setDataFile] = useState(null);
    const [dialogUpload, setDialogUpload] = useState({ dialog: false, show: false });
    const [submitted, setSubmitted] = useState(false);
    const [passType, setPassType] = useState("hide");

    const [searchData] = useState({
        userId: dataUserSession() ? dataUserSession().userId : "",
    });
    const [dataInfo, setDataInfo] = useState({ userRole: "A" });
    const [userRole, setUserRole] = useState("");

    const [typeList, setTypeList] = useState([]);
    const [workUnitList, setWorkUnitList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [contractList, setContractList] = useState([]);

    const [data, setData] = useState({
        contractNo: "",
        password: "",
        position: "",
        profilePhotoPath: "",
        selectedFlag: "",
        telephone: "",
        userId: "",
        userName: "",
        userRole: "",
        userStatus: "",
        userSurname: "",
        workunitCode: "",
    });

    useEffect(() => {
        onSetMultiselectValue();
        setContract(contractList);
    }, [contractList]);

    useEffect(() => {
        // console.log('multiselectValue ',multiselectValue);
    }, [multiselectValue]);

    useEffect(() => {
        onGenWorkunitList();
    }, [userRole]);

    useEffect(() => {
        onP401GetData();
        onGenUserTypeList();
        onGenWorkunitList();
        onGenUserStatusList();
    }, [searchInfo]);

    useEffect(() => {
        if (action && action.action === "แก้ไข") {
            setData(dataInfo);
        } else {
            setData({
                contractNo: "",
                password: "",
                position: "",
                profilePhotoPath: "",
                selectedFlag: "",
                telephone: "",
                userId: "",
                userName: "",
                userRole: "",
                userStatus: "",
                userSurname: "",
                workunitCode: "",
            });
        }
    }, [dataInfo]);

    const onSetMultiselectValue = () => {
        const data = [];
        contractList.forEach((item) => {
            if (item.selectedFlag === "Y") {
                data.push(
                    // code: item.code,
                    item.name
                );
            }
        });

        setMultiselectValue(data);
    };

    const onP401GetData = async (obj) => {
        setLoading(true);
        // await P401GetData( searchInfo).then(
        // 15/03/2022
        await P401GetData(obj !== undefined ? obj : searchInfo).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let tmpSelectList = [];
                    let tmpList = [];
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        if (element.selectedFlag === "Y") {
                            tmpSelectList.push({
                                name: element.contractNo,
                                code: element.contractNo,
                                selectedFlag: element.selectedFlag,
                            });
                        } else {
                            tmpList.push({
                                name: element.contractNo,
                                code: element.contractNo,
                                selectedFlag: element.selectedFlag,
                            });
                        }
                        index++;
                    });

                    setContractList([...tmpSelectList, ...tmpList]);

                    if (temp.length > 0) {
                        setUserRole(temp[0].userRole);
                        setDataInfo(temp[0]);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onSaveFile = () => {
        let reqGen = {
            orderNo: "",
            requestNo: "U$" + data.userId,
            userId: searchData.userId,
        };
        setLoading(true);
        genGetBranchInfo(reqGen).then(
            (res) => {
                setLoading(false);
                if (res && res.length > 0) {
                    onUpload(res[0]);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );

        setDialogUpload({ dialog: false, show: false });
    };

    const onUpload = (dataObj) => {
        let req = {
            base64Pic: deCodeBase64(dataFile.fileUpload),
            picName: formatDateFile(new Date(), true) + "_" + data.userId,
            requestNo: "U$" + data.userId,
            userId: data.userId,
            branchId: dataObj.branchCode,
            fiscalYear: dataObj.fiscalYear,
            picType: dataFile.fileUpload.typefile,
        };

        setLoading(true);
        commonUpload(req).then(
            (res) => {
                setLoading(false);
                if (res && res.status === "Success") {
                    setDataFile({
                        ...dataFile,
                        picPath: res.picPath,
                        picUrl: res.picUrl,
                    });

                    let newData = {
                        ...dataFile,
                        picPath: res.picPath,
                        picUrl: res.picUrl,
                    };

                    onP401CreatePhotoData(newData);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด commonUpload :`, `${res.status}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP401CreatePhotoData = (newData) => {
        let req = {
            profilePhotoPath: newData.picPath,
            thumbnailPhotoPath: newData.picPath,
            userId: data.userId,
        };

        setLoading(true);
        P401CreatePhotoData(req).then(
            (res) => {
                setLoading(false);

                if (res.status === 200) {
                    if (res.data[0].statusText === "") {
                        if (res.data[0].statusCode === "C") {
                            setTextShow(`บันทึกสมบูรณ์ `);
                        } else if (res.data[0].statusCode === "E") {
                            setTextShow(`มีข้อผิดพลาด`);
                        }
                    } else {
                        setTextShow(`${res.data[0].statusText}`);
                    }
                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
                onP401GetData();
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onGenUserTypeList = () => {
        genUserTypeList(searchData).then(
            (res) => {
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setTypeList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const onGenWorkunitList = () => {
        let dataReq = {
            userId: searchData.userId,
            userRole: userRole,
        };
        genWorkunitList(dataReq).then(
            (res) => {
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setWorkUnitList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const onGenUserStatusList = () => {
        genUserStatusList(searchData).then(
            (res) => {
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setStatusList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const validation = (object, type) => {
        let chk = ["userId", "password", "userName", "userRole", "workunitCode", "userStatus"];
        let validate = true,
            setChk = false;

        if (type === "info") {
            chk.forEach((item) => {
                if (!object[`${item}`] || object[`${item}`] === "") {
                    setChk = true;
                    validate = false;
                }
            });
        } else if (type === "copy") {
            if (object.length <= 0) {
                setChk = true;
                validate = false;
            }
        }

        setSubmitted(setChk);
        return validate;
    };

    const submitForm = (submitForm, actionForm) => {
        if (validation(submitForm, "info")) {
            setLoading(true);

            let newContract = "";
            if (multiselectValue && multiselectValue.length > 0) {
                multiselectValue.forEach((item) => {
                    newContract += newContract === "" ? item : "|" + item;
                });
            }

            // if (actionForm === "ลบรายการ") {

            //     submitForm = {
            //         contractorCode: submitForm.contractorCode,
            //         staffId: submitForm.staffSeq,
            //         staffName: submitForm.staffName,
            //         staffPosition: submitForm.staffPositionCode,
            //         telephone: submitForm.staffTelephone,
            //         userId: searchData.userId,
            //         actionCode: "D",
            //     };

            // }else
            if (action.action === "บันทึก") {
                submitForm = {
                    actionCode: "A",
                    contractNo: newContract,
                    editUserId: submitForm.userId,
                    password: submitForm.password,
                    position: NullString(submitForm.position),
                    telephone: submitForm.telephone,
                    userId: searchData.userId,
                    userName: submitForm.userName,
                    userRole: submitForm.userRole,
                    userStatus: submitForm.userStatus,
                    userSurname: submitForm.userSurname,
                    workunitCode: submitForm.workunitCode,
                };
            } else if (action.action === "แก้ไข") {
                submitForm = {
                    actionCode: "U",
                    contractNo: newContract,
                    editUserId: submitForm.userId,
                    password: submitForm.password,
                    position: NullString(submitForm.position),
                    telephone: submitForm.telephone,
                    userId: searchData.userId,
                    userName: submitForm.userName,
                    userRole: submitForm.userRole,
                    userStatus: submitForm.userStatus,
                    userSurname: submitForm.userSurname,
                    workunitCode: submitForm.workunitCode,
                };
            }
            console.log("2", submitForm);
            P401CreateData(submitForm).then(
                (res) => {
                    setLoading(false);

                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setTextShow(`บันทึกสมบูรณ์ `);
                                onChangeAction(2, "แก้ไข");
                            } else if (res.data[0].statusCode === "E") {
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                        } else {
                            setTextShow(`${res.data[0].statusText}`);
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                    // old
                    // onP401GetData();
                    // new 15/03/2022
                    if (action.action === "บันทึก") {
                        onP401GetData({
                            userId: searchData.userId,
                            editUserId: submitForm.editUserId,
                        });
                    } else {
                        onP401GetData();
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const submitFormCopy = (submitForm) => {
        if (validation(submitForm, "copy")) {
            // setLoading(true);
            let newContract = "";
            if (submitForm && submitForm.length > 0) {
                submitForm.forEach((item) => {
                    newContract += newContract === "" ? item : "|" + item;
                });
            }

            setDialog({ ...dialog, dialog: false });

            let req = {
                contractNo: newContract,
                editUserId: data.userId,
                userId: searchData.userId,
            };

            P401ContractCopy(req).then(
                (res) => {
                    setLoading(false);
                    setDialog(false);

                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setTextShow(`บันทึกสมบูรณ์ `);
                            } else if (res.data[0].statusCode === "E") {
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                            // seqPk: 1, statusCode: 'C', statusText: ''
                        } else {
                            setTextShow(`${res.data[0].statusText}`);
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                    onP401GetData();
                },
                function (err) {
                    setDialog(false);
                    setLoading(false);
                    setErrData(err);
                }
            );
        } else {
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });

        if (key === "userRole") {
            setUserRole(val);
        }
    };

    const onShowPassword = (type) => {
        switch (type) {
            case "show": {
                setPassType("hide");
                break;
            }
            case "hide": {
                setPassType("show");
                break;
            }
        }
    };

    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Toast ref={toast} position="top-right" />
            <div className="p-grid  p-fluid">
                <div className="p-col-12 p-md-4">
                    <div className="p-grid" style={{ textAlign: "center" }}>
                        <div className="p-col-12">
                            <Media
                                path={data.profilePhotoPath}
                                alt={data.userName}
                                // type = "video"
                                typefile="person"
                                style={{ width: 250 }}
                            />
                        </div>
                        <div className="p-col-12">
                            <Button className="p-button-warning p-button p-md-12 " icon="pi pi-image" label="เพิ่ม/แก้ไขรูปถ่าย " disabled={action.action === "บันทึก"} style={{ width: 200, marginLeft: "5px", marginTop: "10px" }} onClick={() => setDialogUpload({ dialog: true, show: true })} />
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-8">
                    <div className="p-grid  p-fluid" style={{ marginTop: "10px" }}>
                        <div className="p-col-12 p-md-6">
                            <label>รหัสผู้ใช้งาน</label>
                            {action.action === "บันทึก" ? <span style={{ color: "red" }}>*</span> : ""}
                            <div className="p-inputgroup">
                                <InputText id="userId" placeholder="รหัสผู้ใช้งาน" disabled={action.action === "แก้ไข"} className={classNames({ "p-invalid": !(action.action === "แก้ไข") })} type="text" maxLength="20" onChange={(e) => onInputTextChange(e, "userId")} value={data.userId} />
                            </div>
                            {submitted && !data.userId && validateInputText("userId", "รหัสผู้ใช้งาน")}
                        </div>
                        <div className="p-col-12 p-md-6">
                            <label>รหัสผ่าน</label>
                            <span style={{ color: "red" }}>*</span>
                            <div className="p-inputgroup">
                                <InputText
                                    id="password"
                                    placeholder="รหัสผ่าน"
                                    maxLength="100"
                                    className="p-invalid"
                                    type={passType === "hide" ? "password" : "text"}
                                    onChange={(e) => onInputTextChange(e, "password")}
                                    value={data.password}
                                    // onKeyDown={handleKeyDown}
                                    required
                                    toggleMask
                                />
                                <span className="p-inputgroup-addon" onClick={(e) => onShowPassword(passType)}>
                                    <i className={passType === "hide" ? "pi pi-eye-slash" : "pi pi-eye"} style={{ marginLeft: "0px" }}></i>
                                </span>
                            </div>
                            {submitted && !data.password && validateInputText("password", "รหัสผ่าน")}
                        </div>
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-6">
                            <label>ชื่อ</label>
                            <span style={{ color: "red" }}>*</span>
                            <div className="p-inputgroup">
                                <InputText placeholder="ชื่อ" id="userName" type="text" className="p-invalid" maxLength="200" onChange={(e) => onInputTextChange(e, "userName")} value={data.userName} />
                            </div>
                            {submitted && !data.userName && validateInputText("userName", "ชื่อ")}
                        </div>
                        <div className="p-col-12 p-md-6">
                            <label>นามสกุล</label>
                            <div className="p-inputgroup">
                                <InputText placeholder="นามสกุล" id="userSurname" type="text" maxLength="200" value={data.userSurname} onChange={(e) => onInputTextChange(e, "userSurname")} />
                            </div>
                        </div>
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-6">
                            <label>ประเภทผู้ใช้งาน</label>
                            <span style={{ color: "red" }}>*</span>
                            <div className="p-inputgroup">
                                <Dropdown id="userRole" value={data.userRole} className="p-invalid" onChange={(e) => onInputTextChange(e, "userRole")} options={typeList} optionLabel="userTypeDesc" optionValue="userTypeCode" placeholder="เลือก ประเภทผู้ใช้งาน" />
                            </div>
                            {submitted && !data.userRole && validateInputText("userRole", "ประเภทผู้ใช้งาน")}
                        </div>
                        <div className="p-col-12 p-md-6">
                            <label>สังกัดหน่วยงาน/บริษัทคู่สัญญา</label>
                            <span style={{ color: "red" }}>*</span>
                            <div className="p-inputgroup">
                                <Dropdown id="workunitCode" value={data.workunitCode} className="p-invalid" onChange={(e) => onInputTextChange(e, "workunitCode")} options={workUnitList} optionLabel="workunitName" optionValue="workunitCode" placeholder="เลือก สังกัดหน่วยงาน/บริษัทคู่สัญญา" />
                            </div>
                            {submitted && !data.workunitCode && validateInputText("workunitCode", "สังกัดหน่วยงาน/บริษัทคู่สัญญา")}
                        </div>
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-6">
                            <label>เบอร์ติดต่อ</label>
                            <div className="p-inputgroup">
                                <InputText placeholder="เบอร์ติดต่อ" id="telephone" type="text" maxLength="50" value={data.telephone} onChange={(e) => onInputTextChange(e, "telephone")} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <label>ตำเเหน่ง</label>
                            <div className="p-inputgroup">
                                <InputText placeholder="ตำเเหน่ง" id="position" type="text" value={data.position} onChange={(e) => onInputTextChange(e, "position")} />
                            </div>
                        </div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-6">
                            <label>สถานะการใช้งาน</label>
                            <span style={{ color: "red" }}>*</span>
                            <div className="p-inputgroup">
                                <Dropdown id="userStatus" value={data.userStatus} className="p-invalid" onChange={(e) => onInputTextChange(e, "userStatus")} options={statusList} optionValue="userStatusCode" optionLabel="userStatusDesc" placeholder="เลือก สถานะการใช้งาน" />
                            </div>
                            {submitted && !data.userStatus && validateInputText("userStatus", "สถานะการใช้งาน")}
                        </div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-6">
                            <label>เลขที่สัญญา</label>
                            <MultiSelect
                                value={multiselectValue}
                                options={contract}
                                onChange={(e) => setMultiselectValue(e.value)}
                                optionLabel="name"
                                optionValue="code"
                                placeholder="Select Countries"
                                filter
                                disabled={!contract || contract.length <= 0}
                                itemTemplate={itemTemplate}
                                selectedItemsLabel={selectedItemsLabel}
                            />
                        </div>
                        <div className="p-col-12 p-md-6">
                            <Button
                                className="p-button-warning p-button p-md-12 "
                                icon="fas fa-file-import"
                                label="คัดลอกเลขที่สัญญาจากผู้ใช้รายอื่นฯ "
                                disabled={action.action === "บันทึก"}
                                style={{ width: "auto", marginLeft: "5px", marginTop: "25px" }}
                                onClick={() => setDialog({ dialog: true })}
                            />
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-1"></div>

                <div className="p-col-12 p-md-12" style={{ marginTop: 20, textAlign: "center" }}>
                    <div className="p-grid" style={{ textAlign: "center" }}>
                        <div className="p-col-12">
                            <Button
                                className="p-button p-button-success btn-srh-responsive"
                                icon="pi pi-save"
                                // label={action.action}
                                label={"บันทึก"}
                                style={{ width: 130 }}
                                onClick={() => submitForm(data)}
                            />

                            <Button className="p-button-secondary p-button btn-long-bot-responsive" icon="pi pi-arrow-left" label="กลับหน้าจอแสดงรายการ" onClick={() => onChangeAction(1)} />
                        </div>
                    </div>
                </div>
            </div>

            {dialog.dialog === true ? (
                <>
                    <P401Dialog dialog={dialog} setDialog={setDialog} submitForm={submitFormCopy} submitted={submitted} />
                </>
            ) : (
                ""
            )}

            <DialogUpload
                dialog={dialogUpload}
                setDialog={setDialogUpload}
                dataFile={dataFile}
                setDataFile={setDataFile}
                onSaveFile={onSaveFile}
                // typeFile =".jpg"
            />

            <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
        </>
    );
}
